import styled, { keyframes } from 'styled-components';

const rotateIcon = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(180deg);
  }
`;

export const Container = styled.div`
  font-size: 1rem;
  z-index: 2001;
  min-width: 56vw;
  width: 56vw;
  display: flex;
  flex-direction: column;

  > header {
    padding: 1rem 2.22rem;
    border-bottom: 1px solid #4caf50;
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: space-between;

    > div {
      display: flex;
      align-items: center;
      gap: 1rem;

      > h1 {
        font-family: 'RedHatDisplay-ExtraBold';
        font-size: 1.33rem;
      }
    }
  }
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;

  > svg {
    transition: transform 0.25s ease;
  }

  &:hover {
    background: #f3f4f6;
  }

  &:hover > svg {
    animation: ${rotateIcon} 0.3s ease-in-out;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.89rem 2.89rem;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;

    > h3 {
      text-align: center;
      width: 32vw;
      font-size: 1.22rem;
      line-height: 2rem;
      margin-top: 1rem;
      font-family: 'RedHatDisplay-Regular';
    }
  }

  > form {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > div {
      margin-top: 0.89rem;
      margin-bottom: 1.5rem;
      cursor: text;
      width: 32vw;

      > span {
        font-size: 0.88rem;
        line-height: 2rem;
        margin-bottom: 0.88rem;
      }
    }
  }
`;

export const Logo = styled.div`
  margin-top: 1.67rem;
  border: 2px solid #ff9800;
  height: 6.33rem;
  width: 6.33rem;
  border-radius: 50%;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > .secondary-button {
    font-family: 'RedHatDisplay-ExtraBold';

    text-align: center !important;
    font-size: 1rem;
    color: #1e88e5;
    line-height: 1.28rem;
    padding: 0.77rem 0.72rem 0.77rem 0.88rem;
    border: 1px solid #1e88e5;
    border-radius: 0.55rem;
    height: 2.83rem;
    width: 12.16rem;
  }

  > .primary-button {
    height: 2.83rem;
    width: 12.16rem;
    margin-left: 2rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 1rem;
    border-radius: 0.6rem;
    box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
  }
`;

export const ShareBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #eef6ff;
  border: 1px solid #cfe3ff;
  border-radius: 6px;
  width: fit-content;
`;

export const ShareLink = styled.a`
  color: #0b69c1;
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: #0a57a8;
  }

  &:focus-visible {
    outline: 2px solid #0b69c1;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const CopyButton = styled.button`
  padding: 0.25rem 0.5rem;
  border: 1px solid #cfe3ff;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.875rem;

  &:hover {
    background: #f8fbff;
  }

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid #1e88e5;
    outline-offset: 2px;
  }
`;

export const ClassroomCode = styled.code`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-family:
    ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
  font-size: 1.1rem;
  letter-spacing: 0.08em;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #0f172a;
  user-select: all;
`;
